<template>
    
    <div class="taskpopup">
        <Dialog v-model:visible="visibleRight" :closable="false">
            <template #header>
                <div class="w-100 d-flex justify-content-end">
                    <div>
                        <i class="pi pi-times" @click="isClear()"></i>
                    </div>
                </div>
            </template>
            <TaxMaster @close="$emit('close')" :TaxType="TaxType" :PopupType="PopupType"/>
        </Dialog>
    </div>
    <!-- <RightSidebarNotesTab :leadid=" Number(Id)" :contactid="0" :visibleRight="showDialogNotes"
                @close="closerightsidebar()" /> -->
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue'
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import AutoComplete from "../../../../components/FormComponents/AutoComplete.vue";
import Editor from 'primevue/editor';
import Footer from "../../../../components/FormComponents/Footer.vue";
import TaxMaster from '../../../../modules/Inventory/pages/Masters/Tax/TaxMaster/TaxMasterCreation.vue'
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';

export default defineComponent({
    components: {
        TaxMaster,
        Headerlayout,
        BacktoPage,
        Footer,
        TextField,
    },
    props: {
        lanetype: {
            type: Number,
        },
        statustype: {
            type: Number,
        },
        visibleRight: {
            type: Boolean,
            default: ref(false),
        },
        indexval: {
            type: Number,
        },
        LaneMappingTemplateId: {
            type: Number,
            default: 0
        },
        ITaskDetails: {
            type: Object,
            default: {}
        },
        lanetask: {
            type: Array,
            default: []
        },
        TaxType: {
            type: Number,
            default: 2
        },
        PopupType: {
            type: Number,
            default: 1
        },

    },
    setup(props, { emit }) {
        const usagesarray = ref([false, false, false, false, false]);
        const seconddiv = ref(true);
        const badgevaluenotes = ref(0);
        const badgevaluetasks = ref(0);
        const badgevaluesitevisit = ref(0);
        const activeTab = ref();
        const { t } = useI18n();
        const label = ref(t('btn.save'));
        const router = useRoute();
        let Type = router.query.Type;
        const editItems = ref();



        onMounted(() => {

            badgevaluetasks.value = 0;
        });

        const isForm = ref({
            CreatedAt: "2023-10-03T07:35:05.534Z",
            ModifiedAt: "2023-10-03T07:35:05.534Z",
            CreatedBy: 0,
            ModifiedBy: 0,
            CreatedByName: "",
            EntityId: 0,
            EntityOperationId: 0,
            HospitalId: 0,
            BranchId: 0,
            TaskStatus: 0,
            TaskExpiryDate: "2023-10-03T07:35:05.534Z",
            TaskName: "",
            TaskPriority: 0,
            ResponseTimeInHours: 0,
            IsApprovalRequired: true,
            LevelsOfApproval: 0,
            TaskTypeName: "",
            laneIndex: ref(),

            Id: 0,
            Code: "0",
            OrganizationId: 0,
            LaneMappingTemplateId: 0,
            CarePathwayTemplateId: 1,
            TasktypeId: 0,
            FormFilledBy: 0,
            Name: "",
            Description: "",
            PriorityId: ref(),
            TaskStatusId: ref(),
            Sla: ref(),
            RoleId: 0,
            indexval: 0
        });
        const screenWidth = ref(window.innerWidth);
        // Watch the window.innerWidth and trigger a function when below 768px

        window.addEventListener("resize", () => {
            screenWidth.value = window.innerWidth;
        });
        const istaskComponent = (data) => {
            debugger
            Object.assign(isForm.value, data.value)
            taskinput()
        }
        const taskinput = () => {
            debugger
            emit('taskselected', isForm)
        }
        let deleteid;
        const DeletedTaskId = (data) => {
            debugger
            emit('DeletedTaskId', data)

            emit('close')
        }

        const isClear = () => {
            try {

                emit('close')
                emit("update:selectedItem", undefined);
                emit("load");
            } catch (error) {
                alert(error);
            }
        };
        return {
            isClear,
            isForm,
            istaskComponent,
            editItems,
            usagesarray,
            seconddiv,
            activeTab,
            label,
            status,
            badgevaluenotes,
            badgevaluetasks,
            badgevaluesitevisit,
            DeletedTaskId
        };
    },
});
</script>

<style lang="scss" scoped>
.right-sidebar-close {
    background-color: #3096ff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 10%;
    left: -0.7%;
}

.right-sidebar-close .pi {
    color: White;
    font-size: 12px;
}


// .taskpopup .p-dialog .p-dialog-header {
//     // display: flex;
//     // align-items: center;
//     // justify-content: flex-end !important;
//     // flex-shrink: 0;
// }</style>
